<div
  *transloco="let t"
  class="flex flex-col bg-white border border-surface-subtle rounded-lg overflow-hidden max-h-72 lg:max-h-[calc(100dvh-23.5rem)]"
>
  <div class="bg-surface-card border-b border-surface-subtle px-4 py-3.5 shrink-0">
    <span class="text-xs font-semibold text-primary uppercase tracking-widest">
      {{ t('ORDER-DETAILS.ACTIVITY-LOG') }}
    </span>
  </div>
  <div class="p-4 flex flex-col flex-1 min-h-0" dssLibsUiAutoHideScrollbar>
    @for (item of activities(); track $index) {
    <div class="flex gap-3 items-start">
      <div class="flex flex-col items-center gap-2 pt-2 self-stretch shrink-0">
        <div
          class="w-2.5 h-2.5 rounded-full shrink-0"
          [class]="activityColorClassMapper.get(getActivityVariant(item.activity))?.dot"
        ></div>
        @if (!$last) {
        <div
          class="w-0.5 flex-1 min-h-4 rounded-full"
          [class]="activityColorClassMapper.get(getActivityVariant(item.activity))?.line"
        ></div>
        }
      </div>
      <div class="flex flex-col gap-1 flex-1 min-w-0" [class.pb-4]="!$last">
        <p
          [matTooltip]="item.action"
          matTooltipPosition="below"
          matTooltipClass="tooltip-white"
          dssLibsUiTooltipIfTruncated
          class="text-base font-medium text-ink leading-snug line-clamp-2 lg:line-clamp-1"
        >
          {{ item.action }}
        </p>
        <p class="text-xs text-ink-muted">
          {{ item.dateTime | translocoDate : { dateStyle: 'medium' } }}
          &middot; {{ item.dateTime | translocoDate : { timeStyle: 'short' } }} &middot; {{ item.activity }}
        </p>
      </div>
    </div>
    } @empty {
    <p class="text-center text-ink-muted text-sm py-6">
      {{ t('ORDER_ACTIVITY.NO_DATA_FOUNDED') }}
    </p>
    }
  </div>
</div>
